
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Price": [
      "Levy",
      "RecommendedRetailPrice",
      "TravelloPrice"
    ],
    "MeOrGuestMe": [
      "GuestMe",
      "Me"
    ],
    "UserMedia": [
      "UserProfileImage",
      "UserCoverImage",
      "UserMapImage"
    ]
  }
};
      export default result;
    